import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import makeStyles from '@mui/styles/makeStyles';
import {Theme} from '@mui/material';

import {
    confirmForgotPassword,
    forgotPassword,
    clearForgotPasswordForm
} from '../../store/actions';

import {
    ForgotPasswordEmailForm,
    ForgotPasswordNewPasswordForm
} from '../../components/forgot-password';
import {Text} from '@troy/shared/src/components/common';
import {authForgotPasswordSubmittedSelector, authForgotPasswordUsernameSelector} from "../../store/selectors";

const useStyles = makeStyles((theme: Theme) => ({
    container: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    },
    content: {
        width: '100%',
        maxWidth: '388px',
        padding: `0 ${theme.spacing(2)}`,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        boxSizing: 'border-box'
    }
}));

const ForgotPassword = (): React.ReactElement => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const emailSubmitted = useSelector(authForgotPasswordSubmittedSelector);
    const username = useSelector(authForgotPasswordUsernameSelector);

    const onEmailSubmit = (values: { email: string }): void => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        dispatch(forgotPassword({
            username: values.email,
        }));
    };

    const onNewPasswordSubmit = (values: {
        code: string;
        password: string;
    }): void => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        dispatch(confirmForgotPassword({
            username: username,
            code: values.code,
            newPassword: values.password,
        }));
    };

    const onCancel = (): void => {

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        dispatch(clearForgotPasswordForm());
    };

    return (
        <div className={classes.container}>
            <div className={classes.content}>
                <Text translated variant="h3" component="h1" color="primaryContrast">
                    UNIC_LOGIN_FORGOT_PASSWORD
                </Text>
                <Text
                    translated
                    variant="body1"
                    component="p"
                    color="primaryContrast"
                    align="center"
                >
                    {emailSubmitted
                        ? 'UNIC_LOGIN_PASSWORD_REQUIREMENT'
                        : 'UNIC_LOGIN_ENTER_EMAIL'}
                </Text>
                {emailSubmitted ? (
                    <ForgotPasswordNewPasswordForm
                        onSubmit={onNewPasswordSubmit}
                        onCancel={onCancel}
                    />
                ) : (
                    <ForgotPasswordEmailForm
                        onSubmit={onEmailSubmit}
                        onCancel={onCancel}
                    />
                )}
            </div>
        </div>
    );
};

export default ForgotPassword;
